const SOLANA_RPC_PRIMARY: string = import.meta.env.REACT_APP_SOLANA_RPC_PRIMARY || '';
const SOLANA_RPC_SECONDARY: string = import.meta.env.REACT_APP_SOLANA_RPC_SECONDARY || '';

export const CUSTOM_SOLANA_RPC_NODES = [SOLANA_RPC_PRIMARY, SOLANA_RPC_SECONDARY]
  .map((node) => node.trim())
  .filter(Boolean);

export const CUSTOM_ETHEREUM_RPC: string = (import.meta.env.REACT_APP_ETHEREUM_RPC || '').trim();
